var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 3v15.5c0 1.4-1.2 2.5-2.6 2.5H3.6C2.2 21 1 19.9 1 18.5V3h22m1-1H0v16.5c0 2 1.6 3.5 3.6 3.5h16.8c2 0 3.6-1.6 3.6-3.5V2z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M5 1.1v4.5M19 1.1v4.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 10.2,
    fill: "currentColor",
    r: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10.2,
    fill: "currentColor",
    r: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4,
    cy: 10.2,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    r: 1.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 16.1,
    fill: "currentColor",
    r: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 16.1,
    fill: "currentColor",
    r: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1b5f4a8437ac49951c2ca6e707f776a5.svg";
export { ForwardRef as ReactComponent };